<main class="flex column">
  <button
    payee-button
    (click)="createLawFirm()"
  >
    Ügyvédi iroda létrehozása
  </button>

  <table
    mat-table
    multiTemplateDataRows
    matSort
    class="mat-elevation-z1"
    [dataSource]="dataSource"
  >
    <ng-container matColumnDef="name">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-sort-header
      >
        Név
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        {{ element.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="mokk_cookie">
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        MOKK cookie
      </th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        <button
          payee-mini-icon-button
          color="white"
          [title]="element.has_mokk_cookie ? 'MOKK cookie módosítása' : 'MOKK cookie beállítása'"
          (click)="setMokkCookie(element)"
        >
          <payee-icon [name]="element.has_mokk_cookie ? 'checkmark-green-circle' : 'lock-grey'"></payee-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-sort-header
      ></th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        <button
          payee-mini-icon-button
          color="white"
          (click)="editLawFirm(element)"
        >
          <payee-icon name="pencil"></payee-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="delete">
      <th
        *matHeaderCellDef
        mat-header-cell
        mat-sort-header
      ></th>
      <td
        *matCellDef="let element"
        mat-cell
      >
        <button
          payee-mini-icon-button
          color="white"
          (click)="deleteLawFirm(element)"
        >
          <payee-icon name="trash-red"></payee-icon>
        </button>
      </td>
    </ng-container>

    <tr
      *matHeaderRowDef="displayedColumns"
      mat-header-row
    ></tr>
    <tr
      *matRowDef="let element; columns: displayedColumns"
      mat-row
      class="element-row"
    ></tr>
  </table>
</main>
